import { Controller } from '@hotwired/stimulus'

export default class RangeSliderController extends Controller {
  static targets = [
    'minRange',
    'maxRange',
    'minInput',
    'maxInput',
    'rangeFill'
  ]

  connect() {
    this.syncAll();
  }

  updateFromMinRange() {
    if (this.hasMaxRangeTarget && (parseFloat(this.minRangeTarget.value) > parseFloat(this.maxRangeTarget.value))) {
      this.minRangeTarget.value = this.maxRangeTarget.value;
    }
    this.syncAll();
  }

  updateFromMaxRange() {
    if (parseFloat(this.maxRangeTarget.value) < parseFloat(this.minRangeTarget.value)) {
      this.maxRangeTarget.value = this.minRangeTarget.value;
    }
    this.syncAll();
  }

  updateFromMinInput() {
    let val = parseFloat(this.minInputTarget.value);
    if (this.hasMaxRangeTarget && val > parseFloat(this.maxRangeTarget.value)) {
      val = this.maxRangeTarget.value;
    }
    if (!this.hasMaxRangeTarget && val > this.minRangeTarget.max) {
      val = this.minRangeTarget.max;
    }
    this.minRangeTarget.value = val;
    this.syncAll();
  }

  updateFromMaxInput() {
    let val = parseFloat(this.maxInputTarget.value);
    if (val < parseFloat(this.minRangeTarget.value)) {
      val = this.minRangeTarget.value;
    }
    if (val > this.maxRangeTarget.max) {
      val = this.maxRangeTarget.max;
    }
    this.maxRangeTarget.value = val;
    this.syncAll();
  }

  syncAll() {
    const minVal = parseFloat(this.minRangeTarget.value);
    const minLimit = parseFloat(this.minRangeTarget.min);

    this.minInputTarget.value = minVal;

    if(this.hasMaxRangeTarget) {
      const maxVal = parseFloat(this.maxRangeTarget.value);
      const maxLimit = parseFloat(this.maxRangeTarget.max);

      this.maxInputTarget.value = maxVal;

      const percentMin = ((minVal - minLimit) / (maxLimit - minLimit)) * 100;
      const percentMax = ((maxVal - minLimit) / (maxLimit - minLimit)) * 100;

      this.rangeFillTarget.style.left = `${percentMin}%`;
      this.rangeFillTarget.style.width = `${percentMax - percentMin}%`;
    } else {
      const percent = ((minVal - minLimit) / (this.minRangeTarget.max - minLimit)) * 100;
      this.rangeFillTarget.style.left = `0%`;
      this.rangeFillTarget.style.width = `${percent}%`;
    }
  }
}
